import { cloneDeep, isEqualWith } from 'lodash-es'
import { diff } from 'deep-diff'
import { mapGetters, mapMutations } from 'vuex'

import ExitModal from '@/components/modals/exit-modal'

export default {
  components: {
    ExitModal,
  },
  data: () => ({
    showExitModal: false,
    exitNext: null,
    optionsMap: {
      country: 'countries',
      currency: 'mainCurrencies',
      language: 'translationLanguages',
    },
  }),
  computed: {
    ...mapGetters('options', ['formattedOption']),
  },
  methods: {
    ...mapMutations({
      setPageLoading: 'general/setPageLoading',
    }),
    setBeforeUnloadListener(fn) {
      window.addEventListener('beforeunload', fn)
    },
    removeBeforeUnloadListener(fn) {
      window.removeEventListener('beforeunload', fn)
    },
    confirmUnload(event) {
      event.preventDefault()
      event.returnValue = ''
    },
    clone(data) {
      return cloneDeep(data)
    },
    createChange(context, type, value) {
      return { context, type, value }
    },
    getContextLabel(context, key) {
      const option = this.optionsMap[context]
      if (!option) return

      return this.formattedOption(option, key)
    },
    hasDataChanged(original, updated) {
      return !isEqualWith(original, updated, (a, b) => {
        if (a == undefined && b == undefined) return true
      })
    },
    isArrayChange(type, path) {
      const lastKeyInPath = path.pop()
      return type === 'E' && Number.isInteger(lastKeyInPath)
    },
    formatDiffKey(option, value) {
      if (!option) return value
      return this.formattedOption(option, value)
    },
    getDiff(original, updated) {
      return diff(original, updated)
    },
    getDiffType({ kind, item, lhs, rhs }) {
      switch (kind) {
        case 'N':
          return 'add'
        case 'D':
          return 'delete'
        case 'A':
          return this.getDiffType({ kind: item.kind, lhs, rhs })
        case 'E':
        default:
          if (lhs == undefined) return 'add'
          if (rhs == undefined) return 'delete'
          return 'edit'
      }
    },
    getDiffValue({ item, lhs, rhs }, type) {
      switch (type) {
        case 'delete':
          return item ? item.lhs : lhs
        case 'add':
        case 'edit':
        default:
          return item ? item.rhs : rhs
      }
    },
    getPropertyDataFromSchema(schema, propertyName) {
      const property = Object.entries(schema).find(([key]) => key === propertyName)

      if (!property) return {}

      const [
        ,
        {
          title,
          meta: { context, option },
        },
      ] = property
      return { title, context, option }
    },
    handleExitBeforeSave(next) {
      this.exitNext = next
      this.showExitModal = true
    },
    confirmExitBeforeSave() {
      this.showExitModal = false
      this.setPageLoading(true)
      return this.exitNext()
    },
    cancelExitBeforeSave() {
      this.showExitModal = false
      this.exitNext = null
    },
  },
}
